const SAMPLED_STORAGE_KEY = 'diagramSlownessSampled';

/** Without storage (private mode, blocked) every page load decides again, which keeps the rate right. */
function readStoredDecision(): boolean | undefined {
  try {
    const stored = sessionStorage.getItem(SAMPLED_STORAGE_KEY);

    return stored === null ? undefined : stored === 'true';
  } catch {
    return undefined;
  }
}

function storeDecision(isSampled: boolean) {
  try {
    sessionStorage.setItem(SAMPLED_STORAGE_KEY, String(isSampled));
  } catch {
    // The decision simply is not remembered.
  }
}

/**
 * Whether this browser session is measured. Decided once per session and remembered, so reloading
 * the page does not give a slow session more chances to be picked.
 */
export function isSessionSampled(sampleRate: number, random: () => number = Math.random): boolean {
  const storedDecision = readStoredDecision();

  if (storedDecision !== undefined) {
    return storedDecision;
  }

  const isSampled = random() < sampleRate;

  storeDecision(isSampled);

  return isSampled;
}
